
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { useActivityLogger } from "./useActivityLogger";

export const useQuoteTracking = () => {
  const { logQuoteViewed } = useActivityLogger();

  const trackQuoteView = async (quoteId: string) => {
    try {
      // First get the current view count and booking info
      const { data: quote } = await supabase
        .from('quotes')
        .select(`
          view_count, 
          booking_id, 
          bookings!inner(
            profiles!bookings_user_id_fkey(name, email)
          )
        `)
        .eq('id', quoteId)
        .single();

      const currentCount = quote?.view_count || 0;

      // Update with incremented view count
      const { error } = await supabase
        .from('quotes')
        .update({
          customer_viewed_at: new Date().toISOString(),
          view_count: currentCount + 1
        })
        .eq('id', quoteId);

      if (error) {
        console.error('Error tracking quote view:', error);
        return;
      }

      // Log the activity
      if (quote?.booking_id) {
        const customerProfile = quote.bookings?.profiles;
        await logQuoteViewed(
          quote.booking_id,
          customerProfile?.name,
          customerProfile?.email,
          quoteId
        );
      }
    } catch (error) {
      console.error('Error tracking quote view:', error);
    }
  };

  const trackPaymentLinkView = async (quoteId: string) => {
    try {
      const { error } = await supabase
        .from('quotes')
        .update({
          payment_link_viewed_at: new Date().toISOString()
        })
        .eq('id', quoteId);

      if (error) {
        console.error('Error tracking payment link view:', error);
      }
    } catch (error) {
      console.error('Error tracking payment link view:', error);
    }
  };

  return {
    trackQuoteView,
    trackPaymentLinkView
  };
};
